import {
  xs
} from "./chunk.QLZDQDDJ.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/footer-item/footer-item.styles.ts
var footer_item_styles_default = r` .footer-item { display: inline-block; padding: 0 var(--sl-spacing-large); } ${xs(r` .footer-item { max-width: 100%; padding: 0; display: block; } fadv-button::part(base) { white-space: normal; } `)} `;

export {
  footer_item_styles_default
};
